import { createFileRoute } from "@tanstack/react-router"

const RouteComponent = () => {
  return <div>Oh, something went wrong</div>
}
export const Route = createFileRoute("/error")({
  component: RouteComponent,
})
